import React from 'react';

export default ({ show, colorClass, message }) => {
  if (!show) {
    return null;
  }
  return (
    <p className={`help ${colorClass}`}>
      {message}
    </p>
  );
}



// WEBPACK FOOTER //
// ./src/components/FormMessage/index.js